import { render, staticRenderFns } from "./ProductRecommendation.vue?vue&type=template&id=b56b930e&scoped=true"
import script from "./ProductRecommendation.vue?vue&type=script&lang=js"
export * from "./ProductRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ProductRecommendation.vue?vue&type=style&index=0&id=b56b930e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56b930e",
  null
  
)

export default component.exports